import { render, staticRenderFns } from "./Class.vue?vue&type=template&id=37d3ebfb"
import script from "./Class.vue?vue&type=script&lang=js"
export * from "./Class.vue?vue&type=script&lang=js"
import style0 from "./Class.vue?vue&type=style&index=0&id=37d3ebfb&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports